import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import '../Components/WorkbookStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

import * as UserActions from 'store/modules/UserModule';


class MypageLicenseItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 알림모달
            visibleAlert: false,
            alert: '',

            // 마이페이지
            userInfo: {},

            license_data: [],

            // 프로모션 코드 길이 정해지면 "수정 필요" 부분 length 수정하기
            promotionCode: "",
        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });

        this.dataLoad();
    }

    dataLoad = () => {
        const self = this;
        api.post('/workbook/pay/list', {})
            .then(function (result) {
                if (result.data.result) {
                    let data = result.data.data;
                    self.setState({ license_data: data });
                }
            })
            .catch(err => {
                console.log("tab err", err)
            })
    }

    onChangePromotion = (e) => {
        let code = e.target.value;
        var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
        code = code.replace(regExp, "");

        this.setState({ promotionCode: code })
    }

    onClickPromotionSend = () => {
        // 수정 필요
        if (this.state.promotionCode.length > 5) {
            console.log("code send")
            this.setState({
                alert: "Completed",
                visibleAlert: !this.state.visibleAlert,
            })
        }
    }


    render() {
        let LayoutLicense;

        if (this.props.userInfo && this.props.userInfo.idx) {

            let license_list = [];
            this.state.license_data.forEach(function (data) {
                let dateTime = moment(data.pay_date).format("yyyy.MM.DD") + " ~ " + moment(data.pay_end).format("yyyy.MM.DD");
                let item = (
                    <Row className="classContainer" style={{
                        borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid',
                        paddingTop: '2%', paddingBottom: '2%',
                    }}>
                        <Col xs={12} md={5} className="my-auto" style={{ textAlign: 'left' }}>
                            <p style={{ color: "#666", fontWeight: '500', margin: 0 }}>{data.title}</p>
                            {/* <p style={{ margin: 0, fontSize: 13 }}>{data.sub_name}</p> */}
                        </Col>
                        <Col xs={3} md={1} className="my-auto" style={{ color: "#666", fontWeight: '500' }}>{data.pay_money}$</Col>
                        <Col xs={3} md={2} className="my-auto">{data.pay_module}</Col>
                        <Col xs={6} md={4} className="my-auto period">{dateTime}</Col>
                    </Row>
                )
                license_list.push(item);
            })

            LayoutLicense = (
                <Container className="mypage_license">
                    {license_list}
                </Container>
            )
        }

        let promotionOnStyle = {
            backgroundColor: '#ce3b33', color: '#fff', borderRadius: 50, paddingTop: 5, paddingBottom: 5, paddingLeft: 15, paddingRight: 15, marginLeft: 15
        };
        let promotionOffStyle = {
            backgroundColor: '#ccc', color: '#fff', borderRadius: 50, paddingTop: 5, paddingBottom: 5, paddingLeft: 15, paddingRight: 15, marginLeft: 15
        };

        return (
            <div id="write_ad">
                <div style={{
                    borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid',
                    paddingTop: 20, paddingBottom: 20,
                }}>
                    <input
                        type="text"
                        placeholder="Promotion Code"
                        onChange={this.onChangePromotion}
                        value={this.state.promotionCode}
                        style={{
                            width: '70%',
                            borderRadius: 30, borderWidth: 0, borderColor: '#eee',
                            paddingTop: 5, paddingBottom: 5, paddingLeft: 18, paddingRight: 18,
                            backgroundColor: '#f2f2f2', outline: 'none',
                            color: '#666'
                        }}
                    />
                    {/* 수정 필요 */}
                    <span onClick={this.onClickPromotionSend} style={this.state.promotionCode.length > 5 ? promotionOnStyle : promotionOffStyle} >Send</span>
                </div>
                {LayoutLicense}

                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Col className="my-auto" style={{ textAlign: "center", color: "#9b9daa", fontSize: 18, padding: 0 }}>{this.state.alert}</Col>
                        <Col className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</Col>
                    </Container>
                </Modal>
            </div>
        )
    }
}


let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MypageLicenseItem);